
    import Vue from "vue";
    import Component from "vue-class-component";
    import Store from "@/store/store";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import BriefingProgressIcons from "@/vue/components/BriefingProgressIcons.vue";
    import BriefingProgressBar from "@/vue/components/BriefingProgressBar.vue";
    import { firstPageID, lastPageID, previewVisitID, SiteRegistrationType } from "@/model/Enums";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import { IBriefingResponse } from "@/model/IBriefingResponse";
    import { Site } from "@/model/Site";
    import { Pathway } from "@/model/Pathway";
    import { Visit } from "@/model/Visit";
    import { VisitAnswer } from "@/model/VisitAnswer";
    import { TriState } from "@/model/Enums";
    import { BriefingProgress } from "@/model/BriefingProgress";
    import { LookupItem } from "@/model/LookupItem";

    @Component({ components: { ApiButton, BriefingProgressIcons, BriefingProgressBar } })
    export default class BriefingDone extends Vue {

        async mounted(): Promise<void> {
            this.progress.setResizeObserver("briefing-resize-observer");
            this.visitID = this.$route.params.visitID ?? Utils.emptyGuidValue;
            this.previewPathwayID = Utils.getUrlQueryValue(this.$route, "previewPathwayID");
            this.newRedoVisitID = Utils.getUrlQueryValue(this.$route, "newRedoVisitID");

            const loadVisitorCompanies = async () => { this.visitorCompanyList = await ApiClient.get("/api/visitorCompany/lookups"); }
            const loadRecipients = async () => { this.recipientList = await ApiClient.get(`/api/siteRecipient/lookups?siteID=${Utils.emptyGuidValue}`); }
            await Promise.all([
                loadVisitorCompanies(),
                loadRecipients(),
                this.load(),
            ]);
            setTimeout(() => {
                this.showNavButtons = true;
            }, 1000);
        }

        // so can access in template
        TriState: any = TriState;

        //
        // -- properties
        //

        showNavButtons: boolean = false;
        visitID: string = Utils.emptyGuidValue;
        previewPathwayID: string = Utils.emptyGuidValue;
        newRedoVisitID: string = Utils.emptyGuidValue;
        site: Site = new Site();
        pathway: Pathway = new Pathway();
        visit: Visit = new Visit();
        progress: BriefingProgress = new BriefingProgress();
        isBusySaving: boolean = false;
        pageID: string = lastPageID;
        visitorCompanyList: Array<LookupItem> = [];
        recipientList: Array<LookupItem> = [];

        // get visitCompleted(): string {
        //     return Utils.dateText(this.visit.completed);
        // }

        get isPreviewMode(): boolean {
            return this.visitID === previewVisitID;
        }

        // get answerCount(): number {
        //     if(this.visit?.answers == null) 0;
        //     return this.visit.answers.filter(a => a.isTest).length;
        // }

        // get correctCount(): number {
        //     if(this.visit?.answers == null) 0;
        //     return this.visit.answers.filter(a => a.isTest && a.isCorrect === TriState.True).length;
        // }

        get incorrectAnswers(): Array<VisitAnswer> {
            if(this.visit?.answers == null) return [];
            // make sure red lines come first - but preserve order otherwise
            const redLine = this.visit.answers.filter(a => a.isTest && a.isRedLine && a.isCorrect !== TriState.True);
            const nonRedLine = this.visit.answers.filter(a => a.isTest && !a.isRedLine && a.isCorrect !== TriState.True);
            return redLine.concat(nonRedLine);
        }

        get failedMessage(): string {
            if(this.visit.wrongRedlineAnswerCount == 1) return "You have answered a red-line question incorrectly";
            if(this.visit.wrongRedlineAnswerCount > 1) return "You have answered some red-line questions incorrectly";
            if(this.visit.wrongAnswerCount > this.visit.allowedWrongAnswerCount) return "You have answered too many questions incorrectly.";
            return "- - -"; // shouldn't end up showing this
        }

        get isEmailLink(): boolean {
            return this.site.registrationType !== SiteRegistrationType.WithoutEmail
        }

        //
        // -- methods
        //

        // async goToPrevious() {
        //     //this.$router.push({ name: "Briefing", params: { visitID: this.visitID, pageID: this.page.previousID } });
        //     this.$router.go(-1);
        // }

        async load() {
            // no need to load a page
            const path = this.isPreviewMode
                ? `/api/page/briefing?visitID=${this.visitID}&pageID=${lastPageID}&previewPathwayID=${this.previewPathwayID}`
                : `/api/page/briefing?visitID=${this.visitID}&pageID=${lastPageID}`;
            const data: IBriefingResponse = await ApiClient.get(path);
            this.site.update(data.site);
            this.pathway.update(data.pathway);
            this.visit.update(data.visit);
            this.progress.update(data.progress);
            await Store.dispatch("setSite", this.site);
        }

        redoBriefing() {
            this.$router.push({ name: "Briefing", params: { visitID: this.newRedoVisitID } });
        }
    }
